import {GraphQL} from '../../graphql';
import {ApiBase} from './ApiBase';
import {DestinationCompletion} from '@wix/wixstores-graphql-schema-node';
import {GetDestinationCompletionListQueryVariables} from '../../graphql/queries-schema';

export class DestinationCompletionListApi extends ApiBase {
  /* istanbul ignore next */
  public async getList(variables: GetDestinationCompletionListQueryVariables): Promise<DestinationCompletion[]> {
    const response = await this.siteStore.tryGetGqlAndFallbackToPost(this.endpoint, {
      ...GraphQL.getDestinationCompletionList(variables),
      operationName: 'getDestinationCompletionList',
      source: 'WixStoresWebClient',
    });

    return response.data.destinationCompletionList;
  }
}
